<!-- @format -->

<template>
	<disabled-text v-if="disabled && pcProps.showDisabledText" :value="value" :params="pcProps.params" />
	<el-cascader
		v-else
		v-model="value"
		:disabled="disabled"
		:options="pcProps.cascaderParams"
		:props="cascaderProps"
		clearable
		filterable
	/>
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: any;
		pcProps: WidgetConfigType;
		disabled?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const attr = useAttrs();

	const value = computed({
		get() {
			// 多选，数据结构1/2/3,1/2/3 转为 [[1,2,3],[1,2,3]]
			if (attr.multiple) {
				return props.modelValue ? props.modelValue.split(',').map((itm) => itm.split('/')) : [];
			}
			return props.modelValue ? props.modelValue.split('/') : [];
		},
		set(val) {
			if (attr.multiple) {
				// 多选，数据结构[[1,2,3],[1,2,3]] 转为 1/2/3,1/2/3
				emit('update:modelValue', val ? val.map((itm) => itm.join('/')).join(',') : '');
			} else {
				emit('update:modelValue', val ? val.join('/') : '');
			}
		},
	});

	const cascaderProps = computed(() => ({
		multiple: attr.multiple as boolean,
		checkStrictly: props.pcProps.checkStrictly as boolean,
	}));
</script>

<style scoped></style>
